/* eslint-disable no-undef */
import Vue from 'vue';
import Pubsub from 'pubsub-js';
import moment from 'moment';
import vueDocumentTitlePlugin from 'vue-document-title-plugin';
// eslint-disable-next-line import/no-extraneous-dependencies
import VueLazyLoad from 'vue-lazyload';
import VueClipboard from 'vue-clipboard2';
import CommonTitle from '@/components/header/CommonTitle.vue';
import { UPDATE_CURRENT_TIME } from '@/store/mutations-type';
import { reqServiceTime } from '@/api/common';
import {
  setTokenFromCookie,
  checkIsApp,
  getLocalTime,
  whatEev,
  GetQueryValue,
  judgmentPlatform,
} from '@/utils/tools';
// eslint-disable-next-line import/no-extraneous-dependencies
import App from './App.vue';
import router from './router';
import store from './store';
import './assets/css/reset.css';
import './assets/css/live/lottry.css';
import './assets/css/live/sign.css';
import './assets/css/live/answer.css';
import './utils/vantImport';
import 'vant/lib/index.css';
import 'amfe-flexible';
import './components/vantComponents/vantComponents';
import sendToApp from './utils/sendApp';
import _global from './utils/global';
import communityPopup from './components/communityPopup';

import 'bluebird';
import 'json3';
import 'fetch-polyfill2';
import { reqUserInfo } from './api/index';

import * as filters from './utils/filters';
import * as echarts from 'echarts';


Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});

Vue.use(VueClipboard);
// Vue.use(window['iqh-login']);
// Vue.component('communityPopup', communityPopup);
Vue.use(VueLazyLoad, {
  // eslint-disable-next-line import/no-unresolved
  loading: require('./assets/img/loginImg/banner_out.png'),
  // eslint-disable-next-line import/no-unresolved
  error: require('./assets/img/loginImg/default.png'),
});
setTokenFromCookie();
Vue.use(vueDocumentTitlePlugin, router);
Vue.prototype.Pubsub = Pubsub; // Pubsub全局注册
Vue.prototype.$sendToApp = sendToApp; // 原生交互绑定
Vue.prototype.$echarts = echarts; //将echarts添加到vue的原型上
Vue.prototype.$global = _global; // 原生交互绑定
Vue.prototype.$communityPopup = communityPopup;

Vue.component('CommonTitle', CommonTitle);
const env = GetQueryValue('env');
const miniSource = GetQueryValue('miniSource');
localStorage.setItem('pullNewType', GetQueryValue('pullNewType'));

if (env && env === 'mini') {
  localStorage.setItem('accessToken', GetQueryValue('THIRD_SESSION'));
  localStorage.setItem('sceneMap', GetQueryValue('sceneMap'));
  localStorage.setItem('unionid', GetQueryValue('unionid'));
  if (GetQueryValue('distributorId')) {
    localStorage.setItem('distributorId', GetQueryValue('distributorId'));
  } else {
    localStorage.removeItem('distributorId');
  }
}
const miniBeforePageName = GetQueryValue('miniBeforePageName');
if (miniBeforePageName && miniBeforePageName != 'null' && miniBeforePageName != 'undefined') {
  localStorage.setItem('miniBeforePageName', miniBeforePageName);
}
router.beforeEach((to, from, next) => {
  try {
    // window.romoveAllDoms && window.romoveAllDoms();
  } catch (error) {
    next();
  }
  next();
});

new Vue({
  router,
  store,
  render: (h) => h(App),
  data: {
    isApp: checkIsApp(),
    whatEev: whatEev(),
    isWeiXin: navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1,
    isSafari: navigator.userAgent.toLowerCase().indexOf('safari') !== -1,
    initOperater: '',
    showQuickLogin: true,
    miniprogram: whatEev() === 'miniprogram', // 是否为内嵌小程序
    miniprogramBuyCourse: judgmentPlatform() === 'android', // 指定的版型才能在小程序内购买||安卓
    ytMini: miniSource == 'yt' ? true : false,
    zsbMini: miniSource == 'zsb' ? true : false,
    // zsbMini: true,
    pullNewType: localStorage.getItem('pullNewType')==='yt'? 2: 1 , // 1 启航H5拉新 2 云图拉新H5
  },
  mounted() {
    // 内嵌小程序，如果传入了token，则使用传入的token

    if (GetQueryValue('accessToken') === 'clearToken') {
      window.localStorage.removeItem('accessToken');
      return;
    }

    if (GetQueryValue('accessToken')) {
      window.localStorage.setItem('accessToken', GetQueryValue('accessToken'));
    }
  },
  methods: {
    // 调整登录
    openLogin(path) {
      const param = { redirect: path, ...this.$route.query };
      const routeUrl = this.$router.resolve({
        path: '/ark/registrationLogin',
        query: param,
      });
      console.log('routeUrl', routeUrl);
      window.history.replaceState(null, null, routeUrl.resolved.fullPath);
      window.location.reload();
    },
    async getUserInfo() {
      try {
        const res = await reqUserInfo();
        if (res.code === 0) {
          gio('setUserId', res.data.userCode);
          gio('people.set', 'userPhone', res.data.phone);
          if (window?.mantis) {
            mantis.third = { account: res?.data?.phone, userId: res?.data?.id };
          }
          this.$store.dispatch('saveUserInfo', res.data);
          return res.data;
        }
        if (res?.code !== 0) {
          window.localStorage.removeItem('accessToken');
          store.dispatch('saveUserInfo', {});
        }
      } catch (e) {
        window.localStorage.removeItem('accessToken');
        store.dispatch('saveUserInfo', {});
      }
      return Promise.resolve();
    }, // 将用户信息存储至vuex
    currentTimeUpdate() {
      if (window.currentTimer) clearInterval(window.currentTimer);
      let timeDiff = 0;
      window.currentTimer = setInterval(() => {
        this.$store.commit(UPDATE_CURRENT_TIME, new Date().getTime() + timeDiff);
      }, 1000);
      function timeDiffCalc() {
        reqServiceTime()
          .then((response) => {
            if (response?.code || !response?.data) return;
            timeDiff = moment(response?.data) - moment();
          })
          .catch(() => {});
      }
      timeDiffCalc();
      window.getServerTimer = setInterval(timeDiffCalc, 3600 * 1000);
    },
    async getServerTime() {
      const { data } = await reqServiceTime();
      return data;
    },
    getLocalTime() {
      return getLocalTime();
    },
    checkVersion(version) {
      const ua = window?.navigator?.userAgent;
      // alert(ua.lastIndexOf('/'))
      // alert(ua.slice(ua.lastIndexOf('/')))
      if (ua.slice(ua.lastIndexOf('/') + 1) >= version) return true;
      return false;
    },
    setMiniProgramBuy(data) {
      this.miniprogramBuyCourse = !!(judgmentPlatform() === 'android' || data);
    },
  },
}).$mount('#app');

// 弹出框禁止滑动
Vue.prototype.noScroll = () => {
  // eslint-disable-next-line func-names
  const mo = (e) => {
    e.preventDefault();
  };
  document.body.style.overflow = 'hidden';
  document.addEventListener('touchmove', mo, false); // 禁止页面滑动
};
// 弹出框可以滑动
Vue.prototype.canScroll = () => {
  const mo = (e) => {
    e.preventDefault();
  };
  document.body.style.overflow = ''; // 出现滚动条
  document.removeEventListener('touchmove', mo, false);
};

// 社群组件
Vue.prototype.$communityPopup = function (data) {
  const ToastConstructor = Vue.extend(communityPopup);
  const instance = new ToastConstructor();
  instance.$mount(); 
  document.body.appendChild(instance.$el); 
  instance.show(data);
  instance.$on('hidden', () => {
    document.body.removeChild(instance.$el);
    instance.$destroy();
  });
};
